import { useMemo } from 'react';
import FormattedPrice from '../Utilities/FormattedPrice';
import { GridItem } from 'foundations-components/transitional/components/Grid';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { LEFT_GRID_SIZE, RIGHT_GRID_SIZE } from '../../constants/Sizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LineItemTaxesTotal = ({
  subtotalsPublicResponse,
  currencyCode,
  isUngatedToZeroPercentTax
}) => {
  const taxRate = subtotalsPublicResponse.subtotalsTaxRate;
  const taxText = useMemo(() => {
    if (taxRate) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.taxWithRate",
        options: {
          taxRate
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.tax"
    });
  }, [taxRate]);
  const taxAmount = isUngatedToZeroPercentTax ? typeof subtotalsPublicResponse.firstPaymentTaxAmount === 'number' ? subtotalsPublicResponse.firstPaymentTaxAmount : null : subtotalsPublicResponse.firstPaymentTaxAmount || null;
  if (taxAmount !== null) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(GridItem, {
        size: LEFT_GRID_SIZE,
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(Text, {
          as: "h6",
          children: taxText
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        marginBlockStart: "200",
        "data-test-id": "checkout-line-item-taxes",
        size: RIGHT_GRID_SIZE,
        children: /*#__PURE__*/_jsx(Text, {
          textAlign: "end",
          typography: "body-125",
          children: /*#__PURE__*/_jsx(FormattedPrice, {
            currencyCode: currencyCode,
            price: taxAmount
          })
        })
      })]
    });
  }
  return null;
};
export default LineItemTaxesTotal;